import { array } from 'fp-ts';
import { PortfolioRateOverview } from '@mews-commander/data-access';
import { ActionToolbar } from '@optimus-web/core';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { BulkEdit } from './BulkEdit';
import { BulkDelete } from './BulkDelete';
import { BulkAddVoucher } from './BulkAddVoucher';

interface Props {
    selectedRows: PortfolioRateOverview[];
    resetRowSelection: () => void;
}

export const BulkActions = ({ selectedRows, resetRowSelection }: Props) => {
    const isVouchersFromRatesEnabled = useFeatureFlag(FeatureFlag.vouchersFromRatesEnabled);
    const areNoRowsSelected = selectedRows.length === 0;

    return (
        <ActionToolbar
            disabled={areNoRowsSelected}
            leftSide={
                array.isNonEmpty(selectedRows) && (
                    <LocalizedText textKey={TextKey.SelectedItems} substitutes={{ count: selectedRows.length }} />
                )
            }
            rightSide={
                <>
                    {isVouchersFromRatesEnabled && (
                        <BulkAddVoucher selectedRows={selectedRows} resetRowSelection={resetRowSelection} />
                    )}
                    <BulkEdit selectedRows={selectedRows} resetRowSelection={resetRowSelection} />
                    <BulkDelete selectedRows={selectedRows} resetRowSelection={resetRowSelection} />
                </>
            }
        />
    );
};
